import { render, staticRenderFns } from "./FrozenBrix.vue?vue&type=template&id=6348a724"
import script from "./FrozenBrix.vue?vue&type=script&lang=js"
export * from "./FrozenBrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports